<template>
    <div id="app">
        <router-view />
        <!--登录和注册-->
        <login-modal />
        <register-modal />
        <forgot-password />
    </div>
</template>

<script>
    import {DISPATCH_INIT_SUBJECT_LIST} from "@constants/action-type/subject-action-type";
    import {DISPATCH_INIT_CART_LIST} from "@constants/action-type/cart-action-type";
    import LoginModal from "@components/login/LoginModal";
    import RegisterModal from "@components/login/RegisterModal";
    import ForgotPassword from "@components/login/ForgotPassword";

    export default {
        beforeCreate() {
            this.$store.dispatch(DISPATCH_INIT_SUBJECT_LIST);
            // 设置基本的配置
            this.$store.dispatch('getBrowser')
        },
        created() {
          this.$store.dispatch('')
        },
      components: {
            LoginModal,
            RegisterModal,
            ForgotPassword
        },
        computed: {
            isLogin() {
                return this.$store.state.login.isLogin;
            }
        },
        watch: {
            isLogin() {
                if (this.isLogin) {
                    this.$store.dispatch(DISPATCH_INIT_CART_LIST);
                }
            }
        }
    }
</script>

<style lang="less">
    @import "./styles/variable.less";

    #app {

    }

    // 最大宽度小于 sm
    @media screen and (max-width: @screen-sm) {
        #app {
            width: 100%;
            overflow: hidden;
        }
    }
</style>
